// removed by extract-text-webpack-plugin
module.exports = {"Card":"_1rDzrA8AWEOym8hadk9BA2","Table":"rNzFuNmS5x_HqiM1RJ_Rv","ToggleCell":"ZeLiDBpJvVnsDat-r-d8-","Empty":"_1XXqP6xliICOkTMQ8vDCLb","EmptyRow":"_2PPDfxvafT-9oMTqdafAdG","Row":"_1D3dquo2xE5feEj9rloeKW","InnerRow":"_2TiihyeTt8ukSNjR3ZasQa","Status":"_2cOQU-BL808hAIJ-0nrPaV","Purchase":"_1daWdeTksOm3ygRZwNwEaE","Icon":"_39yzLZRq0Mfm9NWnT7wyVg","TabTable":"_3IZY3FkTxOjEufGHXqodRG","TabIcon":"_3ZJW8_20lQUieHsXUduKpw"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/PayoutsTable/styles.module.css
// module id = 105
// module chunks = 0